import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import API_URL from '../../config';
import './GoogleCalendarSetup.css';

function GoogleCalendarSetup() {
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('');
  const { getAuthHeader } = useAuth();

  useEffect(() => {
    checkStatus();
    // Check status every 5 seconds to detect when OAuth completes
    const interval = setInterval(checkStatus, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/google/calendars`, {
        headers: getAuthHeader()
      });

      if (response.ok) {
        setStatus('connected');
        setMessage('✓ Google Calendar is connected');
      } else {
        setStatus('not_connected');
        setMessage('Google Calendar not connected. Please authorize below.');
      }
    } catch (error) {
      setStatus('not_connected');
      setMessage('Google Calendar not connected. Please authorize below.');
    }
  };

  const handleAuthorize = async () => {
    try {
      const response = await fetch(`${API_URL}/api/google/auth-url`);
      const data = await response.json();

      if (data.authUrl) {
        // Open authorization URL in new window
        const width = 600;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        window.open(
          data.authUrl,
          'Google Calendar Authorization',
          `width=${width},height=${height},left=${left},top=${top}`
        );

        setMessage('⏳ Waiting for authorization... Complete the process in the popup window.');
      }
    } catch (error) {
      console.error('Error getting auth URL:', error);
      setMessage('Error getting authorization URL');
    }
  };

  return (
    <div className="google-calendar-setup">
      <h3>Google Calendar Integration</h3>

      <div className={`status-indicator ${status}`}>
        <div className="status-dot"></div>
        <span>{message}</span>
      </div>

      {status === 'not_connected' && (
        <div className="setup-section">
          <div className="auth-instructions">
            <p>
              Connect your Google Calendar to automatically sync approved reservations.
              When you approve a reservation, it will be added to both your Managers and Guests calendars.
            </p>
          </div>
          <button onClick={handleAuthorize} className="auth-btn">
            Connect Google Calendar
          </button>
        </div>
      )}

      {status === 'connected' && (
        <div className="connected-info">
          <p>✓ Approved reservations will automatically be added to your Google Calendar.</p>
          <div className="calendar-ids">
            <p><strong>Managers Calendar:</strong> {process.env.REACT_APP_MANAGERS_CALENDAR_ID || 'li90l4rfd1m20s59rdpdgcpvok@group.calendar.google.com'}</p>
            <p><strong>Guests Calendar:</strong> {process.env.REACT_APP_GUESTS_CALENDAR_ID || 'g1uajn8j8eq7skc3l41563n6p4@group.calendar.google.com'}</p>
          </div>
          <button onClick={checkStatus} className="refresh-btn">
            Refresh Status
          </button>
        </div>
      )}

      {status === 'checking' && (
        <div className="checking-status">
          <p>Checking connection status...</p>
        </div>
      )}
    </div>
  );
}

export default GoogleCalendarSetup;
